// extracted by mini-css-extract-plugin
module.exports = {"form":"classes_form__18orR","container":"classes_container__py7Hr","header":"classes_header__1D8SH","buttons":"classes_buttons__1y8Vh"};